'use strict';

function LoanLiquidAdditionalPaymentNavigation() {
  this.id = null;
  this.node = null;
  this.declaredClass = null;
  this.extends = [_TrayModal, _Paths];

  this.init = function () {
    this._super();
    this.href = this.paths.loans.liquid.add_payment.type_selection;
  };

  this.initAllReady = function () {
    this._super();
  };

  this._removeCreateAdditionalPaymentData = function () {
    var liquidLoan = this.presenter.models.money.loans.loans[0];
    if (liquidLoan && liquidLoan.create_additional) {
      delete liquidLoan.create_additional;
    }
  };

  this._pushCloseAnalytics = function () {
    this.analytics.forcePushEvent('generic-member-navigation', {
      memberNavigation: ['Money-Navigation-Close-Navigation-Component']
    });
  };

  this.destroy = function () {
    if (location.pathname.indexOf(this.paths.loans.liquid.add_payment.type_selection) === 0) {
      if (location.pathname.length - this.paths.loans.liquid.add_payment.type_selection.length <= 1) {
        this._removeCreateAdditionalPaymentData();
      }
    } else {
      this._removeCreateAdditionalPaymentData();
    }

    this._super();
  };
}